import { CommonModule } from '@angular/common';
import { Injectable, NgModule, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CorePageModule,
  CorePageModuleIDs,
  CoreSelectorGuard
} from '@bepatient/core';
import {
  EDocsActionLoadEDocs,
  selectorEDocsEDocs
} from '@bepatient/edocs-store';
import { IonicModule } from '@ionic/angular';
import { EffectsModule } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EdocsPopoverComponent } from './components/edocs-popover/edocs-popover.component';
import { EDocsViewEffects } from './edocs.effects';
import { EDocsUtilsService } from './services/edocs-utils.service';

@Injectable()
export class EDocsGuard extends CoreSelectorGuard {
  constructor() {
    const store = inject<Store<any>>(Store);

    super(store, selectorEDocsEDocs, new EDocsActionLoadEDocs());
  }
}

const eDocsModule: CorePageModule = {
  ID: CorePageModuleIDs.EDOCUMENTS,
  i18nLabel: 'MODULES.EDOCUMENTS',
  icon: 'copy',
  leftMenuAvailableForPages: [0, 1, 2, 3],
  routes: [
    {
      path: 'documents',
      canActivate: [EDocsGuard],
      loadChildren: () =>
        import('./pages/documents/documents.module').then(
          module => module.DocumentsPageModule
        )
    },
    {
      path: 'document',
      loadChildren: () =>
        import('./pages/document/document.module').then(
          module => module.DocumentPageModule
        )
    },
    {
      path: 'folder',
      loadChildren: () =>
        import('./pages/folder/folder.module').then(
          module => module.FolderPageModule
        )
    }
  ]
};

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    RouterModule.forChild(eDocsModule.routes),
    EffectsModule.forFeature([EDocsViewEffects])
  ],
  providers: [
    EDocsGuard,
    EDocsUtilsService,
    { provide: CORE_PAGE_MODULE, useValue: eDocsModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './edocs/i18n/', multi: true }
  ],
  declarations: [EdocsPopoverComponent],
  exports: [EdocsPopoverComponent]
})
export class EDocsModule {}
